import { Contraparte } from "../contraparte";

export enum FonteCCEE {
  CONV = "CONV",
  I0 = "I0",
  I50 = "I50",
  I80 = "I80",
  I100 = "I100",
  CQ5 = "CQ5",
}

export interface ContraparteCCEE {
  readonly id?: number | null;
  readonly contraparte?: Contraparte | null;
  readonly idCCEE?: string | null;
  readonly fonteCCEE?: FonteCCEE | null;
  readonly agenteCCEE?: string | null;
}
